import React, { useEffect } from "react";
import {
  Box,
  Avatar,
  Typography,
  Button,
  Paper,
  Divider,
  Grid,
  Tooltip,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { AiTwotoneMail } from "react-icons/ai";
import { BsFillBriefcaseFill } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import BackButton from "../../Common/BackButton/BackButton";

const CandidateProfileView = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(CandidateProfile(id));
  }, []);

  const userInfo = useSelector((state) => state.Profile?.result);

  const profileText = [
    { label: "Candidate ID ", value: userInfo?.candidateEmpId || "--" },
    { label: "Skills", value: userInfo?.skillsCategory || "--" },
    { label: "Role", value: userInfo?.currentDesignation || "--" },
    { label: "Vendor ID", value: userInfo?.vendorId || "--" },
    { label: "Graduation", value: userInfo?.graduation || "--" },
    { label: "Intermediate", value: userInfo?.intermediate || "--" },
    {
      label: "Current Company",
      value: userInfo?.currentlyWorkingCompanyName || "--",
    },
    {
      label: "Status",
      value: userInfo?.activeStatus ? "Active" : "Not Active",
      statusColor: userInfo?.activeStatus ? "#22c55e" : "#ef4444",
    },
  ];

  return (
    <Box
      sx={{
        maxWidth: 1100,
        mx: "auto",
        mt: 5,
        p: 3,
      }}
    >
      <BackButton />
      <Paper
        sx={{
          p: 4,
          borderRadius: 4,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        <Grid container spacing={4} alignItems="center">
          {/* Left Profile Section */}
          <Grid item xs={12} sm={4} md={3} textAlign="center">
            <Avatar
              src={userInfo?.profileImageUrl}
              sx={{
                width: 130,
                height: 130,
                mx: "auto",
                fontSize: "40px",
                bgcolor: "#0E3F6F",
              }}
            >
              {(userInfo?.firstName?.[0] || "") +
                (userInfo?.lastName?.[0] || "")}
            </Avatar>

            {/* Resume Button */}
            {userInfo?.resumeFileUrl && (
              <Button
                variant="contained"
                startIcon={<FiDownload />}
                sx={{
                  mt: 3,
                  borderRadius: 2,
                  background: "#1C6597",
                  textTransform: "none",
                  width: "100%",
                }}
                component="a"
                href={userInfo.resumeFileUrl}
                target="_blank"
              >
                View Resume
              </Button>
            )}
          </Grid>

          {/* Name and Quick Details */}
          <Grid item xs={12} sm={8} md={9}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, color: "#0E3F6F", mb: 1 }}
            >
              {userInfo?.firstName} {userInfo?.lastName}
            </Typography>

            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AiTwotoneMail />
                <Typography>{userInfo?.email}</Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <BsFillBriefcaseFill />
                <Typography>
                  {userInfo?.keyExperience
                    ? userInfo.keyExperience + " Years"
                    : "Not Available"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <MdLocationOn />
                <Typography>Noida</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Full Details Section */}
        <Grid container spacing={4}>
          {profileText.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
                {item.label}
              </Typography>

              <Typography
                sx={{
                  fontWeight: 600,
                  mt: 0.5,
                  color: item.statusColor || "#111",
                }}
              >
                {item.value}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default CandidateProfileView;
